// extracted by mini-css-extract-plugin
export default {"ActionMenu_Overlay":"slice-by-menu-module__ActionMenu_Overlay__DpbDrJ1"};